<div class="update-notification">
  <div class="close-button-notification">
    <mat-icon class="close-button" svgIcon="close" (click)="close()"></mat-icon>
  </div>
  <div class="notification-text">
    <span>{{ message | translate }}</span>
  </div>
</div>
